var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-icon{display:inline-block;width:18px;height:18px;background:url(" + escape(require("../images/help.png")) + ") no-repeat;background-size:18px;vertical-align:middle;cursor:pointer}.text-bold{font-weight:600}.riven-layout-left{display:none!important}.riven-layout-header,.riven-layout-right{padding:0!important}", ""]);

// exports
